module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('privacy-terms'), _vm._v(" "), _c('privacy-service')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2c764cba!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/app/PrivacyTerms.vue
// module id = 1292
// module chunks = 1